export default __webpack_public_path__ + "asset/img/icon-watermark~432866b0.png";